// Site Routes
export default [
  {
    path: '/sites',
    name: 'sites.index',
    component: () => import('@/views/sites/SiteIndex.vue'),
    meta: { 
      title: 'Sites Management',
      requiresAuth: true,
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/sites/create',
    name: 'sites.create',
    component: () => import('@/views/sites/SiteCreate.vue'),
    meta: { 
      title: 'Create New Site',
      requiresAuth: true,
      roles: ['sponsor']
    }
  },
  {
    path: '/sites/:id',
    name: 'sites.show',
    component: () => import('@/views/sites/SiteShow.vue'),
    meta: { 
      title: 'View Site Details',
      requiresAuth: true,
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/sites/:id/edit',
    name: 'sites.edit',
    component: () => import('@/views/sites/SiteEdit.vue'),
    meta: { 
      title: 'Edit Site',
      requiresAuth: true,
      roles: ['sponsor','site_representative']
    }
  }
]
